import React from 'react';

export interface FilterToggleProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/**
 * FilterToggle — labeled switch.
 */
export default function FilterToggle({
  label,
  checked,
  onChange,
}: FilterToggleProps) {
  return (
    <div className="min-h-[44px] flex items-center gap-2">
      <label className="flex items-center gap-2 cursor-pointer select-none">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          aria-label={label}
          className="accent-emerald-500"
        />
        <span className="text-sm text-fg-secondary">{label}</span>
      </label>
    </div>
  );
}
